import { Col, Row, Layout, Typography } from "antd";
import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import Feedback from "../../Utilities/Feedback";
import { LoadingOutlined } from "@ant-design/icons";
import {
  getApplications,
  getJobDetail,
  setAllApplications,
  giveOffer,
} from "../../Redux/client/reducer";
import constants from "../../Redux/constants";
import Header from "../../Authorized/Header";
import UserCard from "./ApplicantCard";

const ViewApplications = (props) => {
  const [loadingApplications, setLoadingApplications] = useState(true);
  const { applications, jobDetail } = useSelector((state) => state.clientStore);
  const jobId = props.match.params.jobId;
  const { getApplications, setAllApplications, giveOffer, getJobDetail } =
    props;

  useEffect(() => {
    const getJobDescription = async () => {
      await getJobDetail(jobId);
    };
    getJobDescription();
  }, [getJobDetail, jobId]);

  useEffect(() => {
    const getAllApplications = async () => {
      const responseStatusCode = await getApplications(jobId);
      if (responseStatusCode === constants.status.success) {
        setLoadingApplications(false);
      }
    };
    getAllApplications();
  }, [getApplications, setLoadingApplications, jobId]);
  const removeUser = (userId) => {
    const allApplications = applications.filter(
      (application) => application.user.userId !== userId
    );
    setAllApplications(allApplications);
  };
  const sendProposal = async (applicationId) => {
    const { responseStatus } = await giveOffer(applicationId);
    // await getApplications(jobId);
    return responseStatus;
  };
  return (
    <Layout>
      <Header />
      <Layout.Content>
        <Col xl={{ span: 24 }}>
          <Col>
            {loadingApplications ? (
              <Feedback
                title="Loading Applications"
                icon={<LoadingOutlined />}
              ></Feedback>
            ) : (
              <Col>
                <Row>
                  <JobDecription title={jobDetail.title} />
                </Row>
                {applications.length >= 1 &&
                  applications.map((application, i) => (
                    <UserCard
                      key={i}
                      jobId={jobId}
                      id={application.applicationId}
                      offerId={application.offerId}
                      offerStatus={application.offerStatus}
                      reason={application.reason}
                      user={application.user}
                      comment={application.comment}
                      removeUser={removeUser}
                      sendProposal={sendProposal}
                    ></UserCard>
                  ))}
              </Col>
            )}
          </Col>
        </Col>
      </Layout.Content>
    </Layout>
  );
};

const JobDecription = (props) => {
  return (
    <Col>
      <Typography.Text>{props.title}</Typography.Text>
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getApplications: (jobId) => dispatch(getApplications(jobId)),
    getJobDetail: (jobId) => dispatch(getJobDetail(jobId)),
    setAllApplications: (applications) =>
      dispatch(setAllApplications(applications)),
    giveOffer: (applicationId) => dispatch(giveOffer(applicationId)),
  };
};

export default connect(null, mapDispatchToProps)(ViewApplications);
